import Link from '../../views/ManagementDFuser';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import {push} from "connected-react-router";
import {actions as Authaction} from "../../../state/auth";

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  nextaction: state.shift.assessment.nextaction,
  popwindow: state.shift.status.popwindow,
  username: state.shift.auth.username,
  usersList: state.shift.assessment.usersList,
  alldfList:state.shift.assessment.alldfList,
  customersList:state.shift.assessment.customersList,
  customerdfList:state.shift.assessment.customerdfList,
  dfuserList:state.shift.assessment.dfuserList,
  userlistnotindf:state.shift.assessment.userlistnotindf,
  role: state.shift.auth.role
});
const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {

    // getUserListbydf: (dfname,fn) => {
    //   dispatch(actions.dfusersList(dfname)).then((res)=>{fn(res.value.data)});
    // },

    removeusertodf:(userid,dfid,customerid)=>{
        console.log(userid);
        console.log(dfid);

    //  dispatch(actions.removeusertodf(userid,dfid));   // reomveusertodf not used
    dispatch(actions.delgetdfusersList(userid,dfid)).then(
      setTimeout(() => {
        dispatch(actions.getuserlistnotindf(customerid,dfid));
        //window.location.reload()();
        }, 1000)
    )
    // .then((e)=> {
    //   getuserlistnotindf(customerid,dfid);
    //    // this.props.getUserListbydf(this.state.dfactoryid)
    //      }
    //   );

     // getuserlistnotindf(customerid,dfid);
  
    },

    addusertodf:(userid,dfid,customerid)=>{

      dispatch(actions.addusertodf(userid,dfid))
      .then((e)=> {
       // getuserlistnotindf(customerid,dfid);
        // this.props.getUserListbydf(this.state.dfactoryid)
           }
        );
    
    },


    getCustomerdfList:customer =>{ 
      dispatch(actions.customerdfList(customer));
     //  getCustomerdfList:(customer,fun) =>{ 
     //   dispatch(actions.customerdfList(customer)).then((res)=>{fun({dfs:res.value.data})});
      },


    getUserListbydf: dfname => {
      console.log(dfname);
      dispatch(actions.dfusersList(dfname));
    },


    getalldfList: () => {
      dispatch(actions.alldfList());
    },

    logout: () => {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(Authaction.logout());
    },

    changeAdmin: (oldAdmin,newAdmin,fun) => {
      // console.log(oldAdmin)
      // console.log(newAdmin)
      dispatch(actions.changeAdmin(oldAdmin,newAdmin)).then(
        ()=>{fun()}
      )
    },

    getusersList: username => {
      dispatch(actions.usersList(username));
    },

    inviteUser: (firstName, lastName, email, phoneNumber,adminUsername,role,fun) =>{
      dispatch(actions.register(firstName, lastName, email, phoneNumber,adminUsername,role)).then(()=>fun());
    },

    deleteUser: (username, email, adminUsername,props,selectItem) =>{
      dispatch(actions.unregister(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // props.getusersList(username)
          window.location.reload()();
        }, 1000)
      )
    },

    removeDfUser: (dfuserid, dfid) =>{

      dispatch(actions.delgetdfusersList(dfuserid,dfid));
      // dispatch(actions.unregister(dfuserid)).then(
        // setTimeout(() => {
        //   // selectItem({});
        //   // props.getusersList(username)
        //   window.location.reload()();
        // }, 1000)
      // )
    },

    changeowner :(newownerid,newonername,dfactoryid)=>{ 
      dispatch(actions.changeowner(newownerid,newonername,dfactoryid));
    },

    getuserlistnotindf: (customerid, dfid) =>{ 

      dispatch(actions.getuserlistnotindf(customerid,dfid));
    },


    customersPrjList: (jobtype,customerid)=>{
    dispatch(actions.customersPrjList(jobtype,customerid)).then(data=> data);
  },
    

    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));
    },
    reactiveUser: (username, email, adminUsername,props,selectItem) =>{
      dispatch(actions.reactiveUser(username, email, adminUsername)).then(
        setTimeout(() => {
          // selectItem({});
          // win.getusersList(username)
          window.location.reload()();
        }, 1000)
      )
    },
  }
};

const ManagementDFuser = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default ManagementDFuser;



// WEBPACK FOOTER //
// ./src/components/container/ManagementDFuser/index.js